import React from "react";
import { Grid } from "@mui/material";

export default function ZipCodeFieldContainer({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <>
      <Grid className={`no-pad-left`} size={{ xs: 12, md: 4 }}>
        {children}
      </Grid>
    </>
  );
}
